import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import React from "react";
import {Fragment} from "react"
import ListItems from "./items/ListItems"
import StartRide from "./items/StartRide"
import StopRide from "./items/StopRide"
import AddRide from "./items/AddRide"
import AddFuel from "./items/AddFuel"
import EditRide from "./items/EditRide"


const AppRouter = () => {
    return(
        <Fragment>
            <Router>
                    <Switch>
                        <Route path="/" exact component={ListItems} />
                        <Route path="/startride" component={StartRide} />
                        <Route path="/stopride" component={StopRide} />
                        <Route path="/addride" component={AddRide} />
                        <Route path="/addfuel" component={AddFuel} />
                        <Route path="/edit/:id" component={EditRide} />
                    </Switch>
            </Router>
        </Fragment>
    )
}

export default AppRouter;